// extracted by mini-css-extract-plugin
export default {"outlet":"preferences_outlet__kgbte","title":"preferences_title__p6h55","preferences":"preferences_preferences__qxCf6"};